import { useEffect } from 'react'
import get from 'lodash/get'

export default () => {
  useEffect(() => {
    try {
      const page = get(window, 'analytics.page', () => null)
      page()
    } catch (e) {
      //ignore error when not ready
    }
  }, [])
}
